import React from 'react'
import { Helmet } from 'react-helmet-async'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import Button from '@mui/material/Button'
import Slider from 'react-slick'

import { ReactComponent as Icon } from "../../assets/images/svg/gallery.svg";
import img1 from "../../assets/images/gallery/1.jpg";
// import img2 from "../../assets/images/gallery/2.jpg";
// import img3 from "../../assets/images/gallery/3.jpg";
import img4 from "../../assets/images/gallery/4.jpg";
import img5 from "../../assets/images/gallery/5.jpg";
import img6 from "../../assets/images/gallery/6.jpg";
import img7 from "../../assets/images/gallery/7.jpg";
import img8 from "../../assets/images/gallery/8.jpg";
import img9 from "../../assets/images/gallery/9.jpg";
import img10 from "../../assets/images/gallery/10.jpg";
import img11 from "../../assets/images/gallery/11.jpg";
import img12 from "../../assets/images/gallery/12.jpg";
import img13 from "../../assets/images/gallery/13.jpg";
import img14 from "../../assets/images/gallery/14.jpg";
import img15 from "../../assets/images/gallery/15.jpg";
import img16 from "../../assets/images/gallery/16.jpg";
import img17 from "../../assets/images/gallery/17.jpg";
import img18 from "../../assets/images/gallery/18.jpg";
import img19 from "../../assets/images/gallery/19.jpg";
// import img20 from "../../assets/images/gallery/20.jpg";
import img21 from "../../assets/images/gallery/21.jpg";
import img22 from "../../assets/images/gallery/22.jpg";
import img23 from "../../assets/images/gallery/23.jpg";

import GalleryCard from "../../components/GalleryCard";

const Arrow = ({ className, style, onClick }) => (
  <Button
    style={{ ...style, left: 0 }}
    onClick={onClick}
    className={className}
  />
)

const ArrowRight = ({ className, style, onClick }) => (
  <Button
    style={{ ...style, right: 0 }}
    onClick={onClick}
    className={className}
  />
)

const Gallery = () => {
  return (
    <div className="Gallery" id="gallery">
      <Helmet>
        <title>Gallery | NEOVERA SURVEYING CORPORATION</title>
        <meta
          name="description"
          content="Explore our gallery showcasing field operations, mineral sampling, laboratory testing, and inspection activities carried out by NEOVERA SURVEYING CORPORATION."
        />
        <link rel="canonical" href="https://neoveracsc.com/#gallery" />
      </Helmet>

      <h2 className="headingH2">
        <Icon className="icon" />
        Gallery
      </h2>

      <div className="Gallery__item">
        <Slider
          className='slick-track'
          slidesToShow={3}
          slidesToScroll={3}
          autoplay
          autoplaySpeed={3000}
          prevArrow={<Arrow />}
          nextArrow={<ArrowRight />}
          arrows
          lazyLoad
          height='100%'
          responsive={[
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]}
        >
          <GalleryCard
            image={img1}
            alt="img1"
          />

          {/* <GalleryCard
            image={img2}
            alt="img2"
          /> */}

          {/* <GalleryCard
            image={img3}
            alt="img4"
          /> */}

          <GalleryCard
            image={img4}
            alt="img4"
          />

          <GalleryCard
            image={img5}
            alt="img5"
          />

          <GalleryCard
            image={img6}
            alt="img6"
          />

          <GalleryCard
            image={img7}
            alt="img7"
          />

          <GalleryCard
            image={img8}
            alt="img8"
          />

          <GalleryCard
            image={img9}
            alt="img9"
          />

          <GalleryCard
            image={img10}
            alt="img10"
          />

          <GalleryCard
            image={img11}
            alt="img11"
          />

          <GalleryCard
            image={img12}
            alt="img12"
          />

          <GalleryCard
            image={img13}
            alt="img13"
          />

          <GalleryCard
            image={img14}
            alt="img14"
          />

          <GalleryCard
            image={img15}
            alt="img15"
          />

          <GalleryCard
            image={img16}
            alt="img16"
          />

          <GalleryCard
            image={img17}
            alt="img17"
          />

          <GalleryCard
            image={img18}
            alt="img18"
          />

          <GalleryCard
            image={img19}
            alt="img19"
          />

          <GalleryCard
            image={img21}
            alt="img21"
          />

          <GalleryCard
            image={img22}
            alt="img22"
          />  

          <GalleryCard
            image={img23}
            alt="img23"
          />

        </Slider>

        
      </div>
    </div>
  );
};

export default Gallery;